export const checkIfContainsSpecialCharacter = (val: string) => {
  for (let i = 0; i < val.length; i++) {
    const charCode = val.charCodeAt(i);
    if (
      (charCode > 32 && charCode < 48) ||
      (charCode > 57 && charCode < 65) ||
      (charCode > 90 && charCode < 97) ||
      (charCode > 122 && charCode < 127)
    )
      return true;
  }
  return false;
};

export const isLengthGreaterThanOrEqualToEight = (val: string) => {
  return val.length >= 8;
};

export const containsLowerCase = (val: string) => {

  let containsSmall = false;
  for (let i = 0; i < val.length; i++) {
    if (containsSmall) return true;
    const charCode = val.charCodeAt(i);
    if (charCode > 96 && charCode < 123) {
      containsSmall = true;
    }
  }
  return containsSmall;
};

export const containsUpperCase = (val: string) => {
  let containsCaps = false;

  for (let i = 0; i < val.length; i++) {
    if (containsCaps) return true;
    const charCode = val.charCodeAt(i);
    if (charCode > 64 && charCode < 91) {
      containsCaps = true;
    }
  }
  return containsCaps;
};

export const containsNumber = (val: string) => {
  for (let i = 0; i < val.length; i++) {
    const charCode = val.charCodeAt(i);
    if (charCode > 47 && charCode < 58) return true;
  }
  return false;
};
